import createCache from "@emotion/cache";
import { createStyles, makeStyles } from "@material-ui/core";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { Box, Tooltip } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Formik } from "formik";
import * as React from "react";
import { useState } from "react";
import { useMutation } from "react-query";
import { connect, useSelector } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import ModalCancelPaymentSettlement from "../../components/modals/ModalCancelPaymentSettlement";
import ModalPaymentSettlement from "../../components/modals/ModalPaymentSettlement";
import { ColumnModel } from "../../models/common.model";
import { FilterRegister } from "../../models/loan.model";
import { GetPaymentSettlementResponse } from "../../models/supplierPayment.model";
import {
  GetPaymentSettlementZipFile,
  GetPaymentSettlements,
} from "../../services/supplierPayment.service";

const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: muiSelected,
      },
    },
  })
);

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const columns: readonly ColumnModel[] = [
  { id: "creatorUser", label: "نام کارشناس ثبت کننده      " },
  { id: "createDate_Persian", label: "تاریخ ایجاد" },
  {
    id: "settlementTypeTitle",
    label: "نوع تسویه",
  },
  {
    id: "settlementAmount",
    label: "مبلغ تسویه (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value?.toLocaleString("fa");
    },
  },
  {
    id: "creatorDescription",
    label: "توضیحات",
  },
];
let muiSelected: any;
function TableSettlementWithReceiver({
  stateCartable,
  status,
}: TableCmpPropsInterface) {
  let row: any;
  const jsonFile = useSelector((state: any) => state.style);

  muiSelected = jsonFile?.muiSelected;
  const classes = useStyles();

  const history = useHistory<{
    from: string;
    id: string;
    pageNumber: number;
    clickOnBack: boolean;
  }>();

  const [data, setData] = useState<GetPaymentSettlementResponse[]>([]);
  const [openVerifyModal, setOpenVerifyModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [sendConfirmation, setSendConfirmation] = useState(false);
  const [paymentKey, setPaymentKey] = useState<string>("");
  const [settlementAmount, setSettlementAmount] = useState<number>(0);
  const [reloadData, setReloadData] = useState<string>("");

  const onClickCheckIcon = (key: string, settlementAmount: number) => {
    setPaymentKey(key);
    setSettlementAmount(settlementAmount);
    setOpenVerifyModal(true);
  };
  const onClickCancelIcon = (key: string, settlementAmount: number) => {
    setPaymentKey(key);
    setSettlementAmount(settlementAmount);
    setOpenCancelModal(true);
  };

  window.sessionStorage.setItem("key-tablePaymentSettlmentInfo", "");
  window.sessionStorage.setItem("key-tablePaymentRequestInfo", "");
  React.useEffect(() => {
    let h: any = [];
    let carData = [
      {
        key: "e5e5e5e5e5e5",
        description: "test Description",
        requestDate: new Date(),
        supplierId: 12,
        supplierPaymentSettlementId: 5,
      },
    ];
    h.push(carData[0]);
    setData(h);
  }, []);

  React.useEffect(() => {
    getPaymentSettlementsMutation();
  }, [reloadData]);

  const {
    mutateAsync: getPaymentSettlementsMutation,
    isLoading: isPayment,
  } = useMutation(GetPaymentSettlements, {
    onSuccess: (result: GetPaymentSettlementResponse[]) => {
      if (result) {
        setData(result);
      }
    },
  });
  const {
    mutateAsync: getPaymentSettlementZipFileMutation,
    isLoading: isZipFile,
  } = useMutation(GetPaymentSettlementZipFile, {
    onSuccess: () => {},
  });

  const handleDetail = (key: string, rowIndex: number) => {
    window.sessionStorage.setItem("key-tablePaymentSettlmentInfo", key!);

    history.push({
      pathname: `/Payment/SettlmentRegisterDetail`,
      state: {
        id: key,
        from: "",
        pageNumber: 1,
        clickOnBack: false,
      },
    });
  };

  const filter = new FilterRegister();
  filter.loanRequestStatus = [];
  filter.loanTemplateIds = [];

  const [isShow, setIsShow] = useState(true);

  return (
    <>
      {isShow ? (
        <Box sx={{ flexGrow: 1 }}>
          <Formik initialValues={filter} onSubmit={(values) => {}}>
            {({ handleSubmit, handleChange, values }) => (
              <form onSubmit={handleSubmit}>
                <div className="row"></div>
              </form>
            )}
          </Formik>
        </Box>
      ) : (
        ""
      )}
      <br />
      {
        <>
          <div className="cardTableBorder">
            <TableContainer
              style={{ background: "#fff", maxHeight: "55vh" }}
              className="boxScroll"
            >
              <Table
                stickyHeader
                aria-label="sticky table"
                style={{ borderCollapse: "collapse" }}
              >
                <TableHead
                  className="rowTHead"
                  style={{ paddingBottom: "10px" }}
                >
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${classes} borderRight borderLeft`}
                    // selected={selectedRow === 0}
                  >
                    {columns.map((column) => (
                      <TableCell
                        className="rowTHead colorTitle textFont12 fontWeight noWrap"
                        key={column.id}
                        align="right"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                    <TableCell
                      className="rowTHead colorTitle stickyColO "
                      align="right"
                    ></TableCell>
                  </TableRow>
                </TableHead>
                <div style={{ width: "100%", height: "10px" }}></div>
                <TableBody>
                  {data
                    ? data.map((row, rowIndex) => {
                        return (
                          <TableRow
                            classes={{ root: classes.select }}
                            className={`${
                              rowIndex % 2 == 0 ? "rowTBodyE  " : "rowTBodyO "
                            } ${classes} borderRight borderLeft  noWrap`}
                            hover
                            role="checkbox"
                            tabIndex={-1}
                          >
                            <>
                              {columns.map((column) => {
                                const value =
                                  row[
                                    column.id as keyof GetPaymentSettlementResponse
                                  ];
                                return (
                                  <TableCell
                                    className="textFont12"
                                    key={column.id}
                                    align="right"
                                    onClick={() =>
                                      handleDetail(row.key!, rowIndex)
                                    }
                                  >
                                    {column.format && column.hasFormat
                                      ? column.format(value)
                                      : value?.toString()}
                                  </TableCell>
                                );
                              })}
                            </>
                            <TableCell
                              className={
                                rowIndex % 2 == 0
                                  ? "   alignLeft "
                                  : "   alignLeft"
                              }
                            >
                              <Tooltip arrow title=" دانلود مستندات">
                                <SaveAltIcon
                                  scale="scale(1.8) "
                                  className="cursorPointer"
                                  style={{
                                    color: "#1D4A87",
                                    marginRight: "-5vh",
                                  }}
                                  onClick={() =>
                                    getPaymentSettlementZipFileMutation({
                                      paymentSettlementKey: row.key!,
                                    })
                                  }
                                />
                              </Tooltip>
                              <Tooltip arrow title="تایید تسویه">
                                <CheckIcon
                                  scale="scale(1.8) "
                                  className="cursorPointer"
                                  style={{
                                    color: "#1D4A87",
                                    marginRight: "9px",
                                  }}
                                  onClick={() =>
                                    onClickCheckIcon(
                                      row.key!,
                                      row.settlementAmount!
                                    )
                                  }
                                />
                              </Tooltip>
                              <Tooltip arrow title="لغو تسویه">
                                <CloseIcon
                                  scale="scale(1.8) "
                                  className="cursorPointer"
                                  style={{
                                    color: "#1D4A87",
                                    marginRight: "9px",
                                  }}
                                  onClick={() =>
                                    onClickCancelIcon(
                                      row.key!,
                                      row.settlementAmount!
                                    )
                                  }
                                />
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        );
                      })
                    : null}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </>
      }
      <ModalPaymentSettlement
        openModel={openVerifyModal}
        setSendConfirmation={setSendConfirmation}
        setOpenVerifyModal={setOpenVerifyModal}
        paymentKey={paymentKey}
        settlementAmount={settlementAmount}
        setReloadData={setReloadData}
      />
      <ModalCancelPaymentSettlement
        openModel={openCancelModal}
        setSendConfirmation={setSendConfirmation}
        setOpenVerifyModal={setOpenCancelModal}
        paymentKey={paymentKey}
        settlementAmount={settlementAmount}
        setReloadData={setReloadData}
      />
    </>
  );
}
interface TableCmpPropsInterface {
  stateCartable: any;
  status: any;
}
const mapStateToProps = ({ stateCartable, status }: TableCmpPropsInterface) => {
  return {
    stateCartable,
    status,
  };
};

export default withRouter(
  connect(mapStateToProps)(TableSettlementWithReceiver)
);
const onKeyDown = (e: any) => {
  e.preventDefault();
};
